import BaseModel from './base'
import User from './user'

class CurrentUser extends BaseModel {
  constructor(options) {
    const defaults = {
      admin: false,
      email: null,
      accessToken: null,
      authToken: null,
      className: 'CurrentUser',
      emailDigest: true,
    }

    const userDefaults = new User().defaults
    const mergedDefaults = { ...userDefaults, ...defaults }

    super(options, mergedDefaults)
  }
}

export { CurrentUser as default }
